import { createContext } from 'react';
import { IToastOption } from './toast.interface';

export const ToastMutatorContext = createContext(
  (value: { message: any; options: IToastOption }) => {},
);
